'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _IconList = require('./iconList/IconList');

var _IconList2 = _interopRequireDefault(_IconList);

var _IconTabContentImagePicker = require('./imagePicker/IconTabContentImagePicker');

var _IconTabContentImagePicker2 = _interopRequireDefault(_IconTabContentImagePicker);

var _iconsPopupConstants = require('../iconsPopupConstants');

require('./IconTabContent.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants


// Components
var IconTabContent = function IconTabContent(props) {
    var popupMode = props.popupMode;


    var contentElement = popupMode === _iconsPopupConstants.ICON_POPUP_MODE_IMAGES ? _react2.default.createElement(_IconTabContentImagePicker2.default, props) : _react2.default.createElement(_IconList2.default, props);

    var scrollable = popupMode !== _iconsPopupConstants.ICON_POPUP_MODE_IMAGES;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('IconTabContent', { scrollable: scrollable }) },
        _react2.default.createElement(
            'div',
            null,
            contentElement
        )
    );
};

// Styles
// Lib


IconTabContent.propTypes = {
    popupMode: _propTypes2.default.string
};

exports.default = IconTabContent;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/tabContent/IconTabContent.js
// module id = 2240
// module chunks = 0